import { render, staticRenderFns } from "./GroupNotesAccordion.vue?vue&type=template&id=ffdd31be&"
import script from "./GroupNotesAccordion.vue?vue&type=script&lang=js&"
export * from "./GroupNotesAccordion.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/clinical/multiselect.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports